// src/signalr/signalRConnection.ts
import { env } from "@/config/env";
import { HubConnectionBuilder, HubConnection, LogLevel } from "@microsoft/signalr";

// In dev: empty VITE_BASE_URL → relative '/hub/notifications' (proxied by Vite)
// In prod: full URL → 'https://api.example.com/hub/notifications'
const hubUrl = env.VITE_BASE_URL
  ? `${env.VITE_BASE_URL.replace(/\/$/, "")}/hub/notifications`
  : '/hub/notifications';

let connection: HubConnection | null = null;

export function getSignalRConnection(): HubConnection {
  if (!connection) {
    connection = new HubConnectionBuilder()
      .withUrl(hubUrl, {
        withCredentials: true  // Browser sends HttpOnly cookie automatically on WebSocket upgrade
      })
      .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
      .configureLogging(
        env.DEV ? LogLevel.Information : LogLevel.Error
      )
      .build();
  }
  return connection;
}

export function resetSignalRConnection(): void {
  connection = null;
}
